import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { HashRouter, Route, Routes } from 'react-router-dom';

import { AgentProvider } from './providers/AgentProvider';
import { SignInRoute } from './routes/Trilogic/Auth/SignInRoute';
import { SignUpRoute } from './routes/Trilogic/Auth/SignUpRoute';
import { HubRoute } from './routes/Trilogic/HubRoute';
import { ModuleRoute } from './routes/Trilogic/ModuleRoute';

import { PageNotFound } from './routes/PageNotFound';
import { LogicManagerReportRoute } from './routes/LogicManager/LogicManagerReportRoute';
import { ThemeProvider } from './providers/ThemeProvider';
import { createTheme } from '@mui/material';
import { MessageProvider } from './providers/MessageProvider';
import { EmailVerificationRoute } from './routes/Trilogic/Auth/EmailVerificationRoute';
import { ResetPasswordRoute } from './routes/Trilogic/Auth/ResetPasswordRoute';
import { LoadingProvider } from './providers/LoadingProvider';
import { UpdateUserRoute } from './routes/Trilogic/Auth/UpdateUserRoute';
import { LogicManagerModuleMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerModuleRoute/LogicManagerModuleMaintainRoute';
import { LogicManagerMainRoute } from './routes/LogicManager/LogicManagerMainRoute';
import { LogicManagerModuleDetailRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerModuleRoute/LogicManagerModuleDetailRoute';
import { LogicManagerUserMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerUserRoute/LogicManagerUserMaintainRoute';
import { LogicManagerSchoolMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerSchoolRoute/LogicManagerSchoolMaintainRoute';
import { LogicManagerClassMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerClassRoute/LogicManagerClassMaintainRoute';
import { LogicManagerCourseMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerCourseRoute/LogicManagerCourseMaintainRoute';
import { TouchBackend } from 'react-dnd-touch-backend';
import QuestionsRoute from './routes/Trilogic/QuestionsRoute';
import { decryptKey } from './globalFunctions';
import { LogicManagerQuestionRoute } from './routes/LogicManager/LogicManagerQuestionRoute';
import { LogicManagerEquipeMaintainRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerEquipeRoute /LogicManagerUserMaintainRoute';
import { LogicManagerGeneralReportRoute } from './routes/LogicManager/LogicManagerGeneralReportRoute';

import { CharacterRoute } from './routes/Trilogic/CharacterRoute';
import { LogicManagerEventsRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerEventsRoute';
import { LogicManagerFeedbackRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerFeedbackRoute';
import { LogicManagerLogoRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerLogoRoute';
import { LogicManagerPublicationRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerPublicationsRoute';
import { QuizMaker } from './routes/LogicManager/QuizMaker';
import { ComputacionalThinkingQuiz } from './routes/ComputacionalThinking';
import { EditorFases } from './routes/LogicMaker/editor';
import { LogicMaker } from './routes/LogicMaker';
import { ConfigTeste } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/ConfigTeste';
import { LogicManagerFeedbacksRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerFeedbacksRoute';
import { LogicManagerKombatRoute } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerKombatRoute';
import { LogicMakerModulos } from './routes/LogicMaker/modulos';
import { Game } from './routes/LogicManager/Game';
import { BancoQuestoes } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerBancoQuestoes';
import { EfeitosSonoros } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/LogiManagerEfeitosSonoros';
import ModuleAnalytics from './routes/LogicMaker/ModuleAnalytics';
import { DataTeste } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/segundoTeste';
import { PcReports } from './routes/LogicManager/LogicManagerMainRoute/EditRoute/PcReports';
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const Backend = isMobile ? TouchBackend : HTML5Backend; 



export const App = () => {
    const defaultTheme = createTheme({
        palette: {
            mode: 'light'
        }
    });

    console.log(decryptKey("$2y$10$YCRCvdYYcAsMHjm00UUUZ.IBLCAY7LdgWLo.2/zyGaheKdLBwLlZa"))

    return (
        <ThemeProvider>
            <DndProvider backend={Backend} >
                <MessageProvider>
                    <LoadingProvider>
                        <AgentProvider>
                            <HashRouter>
                                <Routes>
                                    {/* Trilogic Routes */}
                                    <Route path='/auth/sign-in' element={<SignInRoute />} />
                                    <Route path='/auth/sign-up' element={<SignUpRoute />} />
                                    <Route
                                        path='/auth/user/pending-update'
                                        element={<UpdateUserRoute />}
                                    />
                                    <Route
                                        path='/auth/email-verification'
                                        element={<EmailVerificationRoute />}
                                    />
                                    <Route
                                        path='/auth/reset-password'
                                        element={<ResetPasswordRoute />}
                                    />
                                    <Route path='/' element={<HubRoute />} />
                                    <Route path='/module/:moduleId' element={<ModuleRoute />} />
                                    <Route path='/questionario' element={<QuestionsRoute/>} />

                                    {/* LogicManager Routes */}
                                    <Route path='/manager' element={<LogicManagerMainRoute />} />
                                    <Route
                                        path='/manager/edit/schools'
                                        element={<LogicManagerSchoolMaintainRoute />}
                                    />
                                    <Route
                                        path='/manager/edit/courses'
                                        element={<LogicManagerCourseMaintainRoute />}
                                    />
                                    <Route
                                        path='/manager/edit/classes'
                                        element={<LogicManagerClassMaintainRoute />}
                                    />
                                    <Route
                                        path='/manager/edit/users'
                                        element={<LogicManagerUserMaintainRoute />}
                                    />
                                     <Route
                                        path='/manager/edit/equipe'
                                        element={<LogicManagerEquipeMaintainRoute/>}
                                    />
                                     <Route
                                        path='/manager/configPerguntas'
                                        element={<LogicManagerKombatRoute/>}
                                    />
                                    <Route
                                        path='/manager/edit/modules'
                                        element={<LogicManagerModuleMaintainRoute />}
                                    />
                                    <Route
                                        path='/manager/edit/module/:moduleId'
                                        element={<LogicManagerModuleDetailRoute />}
                                    />
                                    <Route
                                        path='/manager/report'
                                        element={<LogicManagerReportRoute />}
                                    />
                                    <Route
                                        path='/manager/questionario'
                                        element={<LogicManagerQuestionRoute />}
                                    />
                                    <Route
                                        path='/manager/generalReport'
                                        element={<LogicManagerGeneralReportRoute/>}
                                    />
                                    
                                    <Route
                                        path='/manager/feedback'
                                        element={<LogicManagerFeedbackRoute/>}
                                    />

                                    <Route
                                        path='/manager/logo'
                                        element={<LogicManagerLogoRoute/>}
                                    />

                                    <Route
                                        path='/manager/publications'
                                        element={<LogicManagerPublicationRoute/>}
                                    />
                                     <Route
                                        path='/manager/events'
                                        element={<LogicManagerEventsRoute/>}
                                    />
                                     <Route
                                        path='/manager/editor'
                                        element={<EditorFases/>}
                                    />
                                     <Route
                                        path='/manager/logicmaker'
                                        element={<LogicMaker/>}
                                    />
                                     <Route
                                        path='/manager/logicmakerModules'
                                        element={<LogicMakerModulos/>}
                                    />
                                      <Route
                                        path='/manager/logicmakerModules/:id'
                                        element={<ModuleAnalytics/>}
                                    />
                                    <Route
                                        path='/manager/configTeste'
                                        element={<ConfigTeste/>}
                                    />
                                    <Route
                                        path='/manager/segundoTeste'
                                        element={<DataTeste/>}
                                    />
                                     <Route
                                        path='/manager/feedbacks'
                                        element={<LogicManagerFeedbacksRoute/>}
                                    />

                                    <Route
                                        path='/manager/quiz'
                                        element={<QuizMaker/>}
                                    />
                                    <Route
                                        path='/manager/game'
                                        element={<Game/>}
                                    />
                                     <Route
                                        path='/manager/bancoQuestoes'
                                        element={<BancoQuestoes/>}
                                    />
                                     <Route
                                        path='/manager/efeitosSonoros'
                                        element={<EfeitosSonoros/>}
                                    />
                                    <Route path='/charactermaker' element={<CharacterRoute/>}></Route>
                                    <Route path='/pc' element={<ComputacionalThinkingQuiz/>}></Route>
                                    <Route path='/manager/pc' element={<PcReports/>}></Route>

                                    {/* PageNotFound Route */}
                                    <Route path='*' element={<PageNotFound />} />
                                </Routes>
                            </HashRouter>
                        </AgentProvider>
                    </LoadingProvider>
                </MessageProvider>
            </DndProvider>
         </ThemeProvider>
    );
};
